import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-09-25'
        tag='Poshmark'
        title='Poshmark Inventory: Where To Get Clothes That Sell'
      >
        <p>
          As online marketplaces continue to thrive, it has become easier to pull out pre-loved apparel, accessories,
          and items from our closets to sell. Whether you are a long-time Poshmark seller or a newbie, here is a list of
          some of the places you can source inventory.
        </p>

        <h3>Closet and Donations</h3>
        <p>
          What you may think are old or vintage pieces from your own closet can turn out to be great finds for others.
          It is understandable you may find it difficult to let go of certain clothes you love. Yet focus on the part
          that once you sell them, you are not only making room for newer ones but earning all at the same time.
        </p>
        <p>
          You may also opt to ask for donations from family members and friends. For certain, they have unwanted
          clothing and accessories they want to pull out as well. When you gather more items, this gives you a wider
          selection to sell on Poshmark. From different sizes, styles, and tastes, your listings would have variety,
          attracting diverse buyers.
        </p>
        <p>
          When you choose clothes to sell, make sure they are still wearable and presentable. You have to take good
          photos as well so these would look professional. In turn, more people would flock to your listings and are
          encouraged to make a purchase.
        </p>

        <h3>Thrift stores</h3>
        <p>
          Sourcing through thrift stores is an ideal way to broaden your selection of offerings. Every state has its
          list of thrifting destinations and so a quick Google search can help you track and visit them. Some of these
          include Goodwill, Goodwill outlets, Ocean Beach Antique Mall in San Diego, American Thrift in Hollywood, and
          Salvation Army.
        </p>
        <p>
          When you sell clothes from local thrift stores, ensure these are properly washed and steamed or ironed before
          you take photos and pack them when there is a sale. While some pieces are branded or limited edition, take
          note that buyers would still want to receive them in the best condition possible.
        </p>

        <h3>Yard sales</h3>
        <p>
          Similar to thrift stores, yard sales can give you low prices for pre-loved items that sometimes turn out to be
          high-end brands. These can range from vintage jeans, quality sweaters, to embroidered purses. The major
          difference is you have to bring change and use your bargaining skills to haggle prices.
        </p>
        <p>
          Before you visit the sales, research the value of items you are interested in. Visit other listings on
          Poshmark and even Depop to compare prices. This gives you an estimate or information about how much you can
          negotiate for an item.
        </p>
        <p>
          When it is clear you know about the items well, the sellers in the yard or garage sale will give you what you
          bargained for, rather than giving you the short end of the stick.
        </p>

        <h3>Estate sales</h3>
        <p>
          If you are the type to search beyond typical vintage pieces, you can scour through what can be considered
          “treasure hunts” amid the sea of secondhand items: estate sales. For those unfamiliar, these sales involve
          purchasing items inside someone’s house or residence.
        </p>
        <p>
          What you can find are mostly intimate pieces such as personal trinkets, clothes, and decorative items, and
          even rare collections of art, rugs, and dinnerware. You will be amazed at what you can get your hands on at
          these estate sales.
        </p>
        <p>
          To find one near you, you can search on websites like estatesales.org or estatesales.net. A quick run-through
          can help you target the type of estate sale you like and pencil book your schedule for a visit. It is also
          good to note that you can subscribe to the emailing list so you will be among the first ones to be notified
          when a sale near you will be held.
        </p>
        <p>
          Some tips for visiting estate sales are one, take a look at the photos of the items that will be sold. This
          helps you gauge the type of pieces you will see and also shortens the time you will navigate through the house
          once there. Two, get to the sale as early as possible. Even if you already have your eyes on particular items,
          an online reservation is not possible. You have to be there to ‘grab it’ or call ‘dibs’ on it so others won’t
          take it anymore. Lastly, for larger pieces, be sure to take their corresponding tickets and hand them over to
          the host to reserve them. Once the host has them, it means you are already buying them after you finished
          shopping throughout the house.
        </p>

        <h3>Flea Markets</h3>
        <p>
          With calls for sustainability, patronizing second-hand products is a must. From clothing, accessories, decor,
          to furnishings, you can find and bargain for all these in flea markets. Similar to estate sales, these are
          your go-to destinations if you are searching for retro or rare pieces that scream originality or creativity.
        </p>
        <p>
          What is good with visiting these markets is you can negotiate for the price, similar to thrift stores. Apart
          from checking the value of similar products online, you have to research the price of vintage items. The
          latter can include a limited edition collection of a brand. These can be seasonal bags, dresses, shoes, and
          more.
        </p>
        <p>
          Take note that some flea markets don’t pop up frequently as yard sales and estate sales. This is why those
          happening once a month or even once a year are usually behemoth markets. These are highly-coveted for the rare
          items and unusual souvenirs that you are unable to find elsewhere.
        </p>

        <h3>Online Arbitrage</h3>
        <p>
          Buyers on Poshmark frequently look for new listings and so as a seller, you must always find ways to release
          fresh blog posts. Beyond relisting or tweaking your existing offerings, you may look through online retailers.
          Some brands like Michael Kors, Macy’s, and Nordstrom Rack release seasonal sales.
        </p>
        <p>
          What you need to do is to navigate through the sales pages of these brands. They have certain items you can
          get for low prices--a great deal considering these are brand-new or never-before-used style pieces.
        </p>
        <p>
          You may opt to subscribe to their email listing so they can give alerts or notifications whenever there is a
          sale. In this way, you are part of the early ones who can get their hands on these branded offerings.
        </p>

        <h3>Consignment or Reselling</h3>
        <p>
          When a shop sells goods for an owner, this is referred to as Consignment. The owner who brought the items to
          the store still owns the items until these are sold. The owner of the shop decides the price, taking into
          account the value of each item. In case the items are not sold, these can be returned to the owner of the
          items.
        </p>
        <p>There are two kinds of consignment which you, as a buyer, can visit and source out your requirements.</p>
        <p>
          First are <b>Consignment Shops</b>. Here, you can catch high-end brands. Sometimes these are priced relatively
          low because some shop owners give further discounts on items that the seller hasn’t monitored or picked up
          after an agreed period. The disadvantage of visiting these shops is that there isn’t much inventory available.
        </p>
        <p>
          Second, <b>Consignment Sales</b>. These are events usually done on weekends that may run from two to four
          days. Many people come to these events to go over an assortment of items. Many resellers prefer this over
          shops because of its incredibly large inventory, thereby allowing you to buy a wider range of items for your
          offerings.
        </p>

        <h3>Craigslist, Facebook Marketplace, and eBay</h3>
        <p>
          These three are some of the most well-known and stable online marketplaces out there apart from Amazon. They
          are easy to navigate and filter through for their simple web designs and especially since they target your
          location. When buying items, shipping fees are generally cheaper as the sources are oftentimes near your
          residence or even within your city or community.
        </p>
        <p>
          Unlike other websites, these platforms need not constantly evolve. Craigslist and eBay maintain an old-school
          look to focus on functionality while Facebook only changes to personalize experiences.
        </p>
        <p>
          In these destinations, apart from buying individual pieces, you can purchase clothes in bulk as well. But
          first, take note of its difference with wholesale lots. The latter typically comes from the manufacturers or
          suppliers themselves. Bulk lots, on the other hand, can be eBay sellers gathering different brands of clothing
          together, with varied styles and sizes.
        </p>
        <p>
          Be careful with searching for these particular listings as sometimes, eBay is unable to monitor and verify
          these wholesale lots. Some sellers may list them as such but in truth, they are not for wholesale.
        </p>
        <p>
          Another downside to purchasing online is you are uncertain if what you are buying is still in good condition
          and resellable. Keep in mind scams are prominent in the digital space. If the seller is in a hurry to give
          away the clothing, these may not be in good condition. Additionally, the actual items may not be as good as
          they look in photos. Worse, the seller may deliver you completely different products.
        </p>
        <p>
          This is the reason buying clothes online remains a risk. You must remain cautious and keep asking the seller
          for more information, ask for recent photos of the clothes, and study the return policy before you transact
          with them. These tips will help you get your hands on items that sell.
        </p>

        <h3>OneShop</h3>
        <p>
          Managing an online business such as Poshmark is a time-consuming and laborious task. Often, sellers get caught
          in a pile of tasks, yet there is so little time to do them all. Using a marketing service like OneShop is a
          great way to help you accomplish the tasks of growing your business while helping you save time so you can
          focus on taking better pictures for your listings. Furthermore, OneShop offers a background removal for images
          via PhotoRoom, making it easier for you to edit your Covershots and Detail photos.
        </p>
        <p>
          In addition to this, you don't have to worry about the Poshmark tasks in your closet such as sharing,
          following, relisting, returning shares & follows, and sending discounts and offers anymore as tasks can be
          made easier and faster with an automated tool like OneShop.
        </p>
        <p>
          If you are ready to experience having more time focusing on different aspects of your business without
          compromising the growth of your Poshmark closet, we offer a 7-day free trial with no credit card or commitment
          required!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
